import Debug from 'bloko/common/core/Debug';
import LocalStorageWrapper from 'bloko/common/storage/LocalStorageWrapper';

// eslint-disable-next-line no-restricted-imports
import { EventParams, sendEvent } from './analytics';

const ANALYTIC_EVENTS_STORAGE = 'analyticEvents';

const getAnalyticEvents = function () {
    try {
        return JSON.parse(LocalStorageWrapper.getItem(ANALYTIC_EVENTS_STORAGE) || '{}') as Record<string, EventParams>;
    } catch (error) {
        return {};
    }
};

/**
 * Модуль для отсылки событий для аналитики.
 *
 * @type {Object}
 * @exports HHC/Analytics
 */
const VendorAnalytics = {
    /**
     * Положить событие для отложенной отсылки, используется в случаях,
     * когда событие генерируется во время перехода страницы, например по клику на ссылку с переходом.
     */
    eventToStorage(
        category: string,
        event: string,
        label: string,
        value?: number,
        params?: Record<string, unknown>
    ): void {
        if (window.globalVars.features.disable_counters || window.globalVars.countersDisabled) {
            return;
        }

        const analyticEvents = getAnalyticEvents();
        const hash = [category, event, label, value].join('*');

        analyticEvents[hash] = {
            category,
            event,
            label,
            value,
            params,
        };

        LocalStorageWrapper.setItem(ANALYTIC_EVENTS_STORAGE, JSON.stringify(analyticEvents));
        Debug.log('info', 'Analytics event storaged:', category, event, label, value, params);
    },
    /**
     * Отправляет отложенные события аналитики
     */
    processPostponed(): void {
        const analyticEvents = getAnalyticEvents();

        for (const id in analyticEvents) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const parseValue = parseInt(analyticEvents[id].value, 10);

            sendEvent(
                analyticEvents[id].category,
                analyticEvents[id].event,
                analyticEvents[id].label,
                isNaN(parseValue) ? undefined : String(parseValue),
                undefined,
                analyticEvents[id].params
            );
        }

        LocalStorageWrapper.removeItem(ANALYTIC_EVENTS_STORAGE);
    },
};

export default VendorAnalytics;
